/* eslint-disable comma-dangle */
/* eslint-disable class-methods-use-this */
/* eslint no-restricted-globals: ["error", "event"] */

import { escape as escapeHTML } from "html-escaper";
import dateFormat from 'dateformat';
import CurrencyFormatter from '../../../../utils/currency-formatter-lib';
import { getNumberWithDecimals } from '../../../../utils/number-utils';
import { FinalBalanceDue } from '../../utils/final-balance-due';
import StringUtils from '../../../../utils/string-utils';
import { orderStatus } from '../../constants/orderStatus';
import DateHelper from '../../../../utils/date-helper';
import Tooltip from '../../../../utils/tooltip';
import DownloadBase64 from '../../../../utils/download-base64';
import AnalyticsHelper from '../../../../utils/analytics-helper';
import { getBanner, addTooltips } from '../../../../utils/promotions-helper';

export default class OrdersView {
    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.el = parent.el.querySelector('.orders-view');
        this.retailerLinkContainer = this.el.querySelector('.retailer-link-wrapper');
        this.retailerLink = this.retailerLinkContainer.querySelector('.retailer-link');
        this.retailerLink.href = '#';
        this.hideElements([this.retailerLinkContainer]);
        this.container = this.el.querySelector('.orders-tab-container');
        this.dealerUrl = this.container.dataset.dealerUrl;
        this.orders = '';
        this.paymentLink = '#';
        this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
        this.utils = {
            formatPrice: new CurrencyFormatter().to,
            stringReplace: StringUtils.replace,
        };
        this.currencyFormatter = new CurrencyFormatter();
        this.orderSummaryTileTemplate = this.getCompiledTemplate('#orderSummaryTile');

        /* Order status templates */
        this.orderTermsCondition = this.getCompiledTemplate('#order-terms-condition');
        this.interestSubmitted = this.getCompiledTemplate('#order-status-interest-submitted');
        this.awaitingDepositPaymentTemplate = this.getCompiledTemplate('#order-status-awaiting-deposit');
        this.depositPlacedTemplate = this.getCompiledTemplate('#order-status-deposit-placed');
        this.orderConfirmedTemplate = this.getCompiledTemplate('#order-status-order-confirmed');
        this.orderCancelledTemplate = this.getCompiledTemplate('#order-status-order-cancelled');
        this.orderStatusCancellationPending = this.getCompiledTemplate('#order-status-cancellation-pending');
        this.awaitingConfigurationConfirmationTemplate = this.getCompiledTemplate('#awaiting-configuration-confirmation');
        this.configurationConfirmedTemplate = this.getCompiledTemplate('#configuration-confirmed');
        this.awaitingB2CSalesContractSignatureTemplate = this.getCompiledTemplate('#awaiting-b2c-sales-contract-signature');
        this.b2CSalesContractSignedTemplate = this.getCompiledTemplate('#b2c-sales-contract-signed');
        this.handoverBookedTemplate = this.getCompiledTemplate('#handover-booked');
        this.finalBalanceDueTemplate = this.getCompiledTemplate('#final-balance-due');
        this.readyForHandoverTemplate = this.getCompiledTemplate('#ready-for-handover');
        this.handoverPendingTemplate = this.getCompiledTemplate('#handover-pending');
        this.handoverCompleteTemplate = this.getCompiledTemplate('#handover-complete');
        this.timelineOrderDocumentsTemplate = this.getCompiledTemplate('#timelineOrderDocumentsTemplate');
        this.invalidOrderTemplate = this.getCompiledTemplate('#invalid-order');

        this.orderIDTemplate = this.getCompiledTemplate('#orderDropdown');
        this.orderStatusFallbackTemplate = this.getCompiledTemplate('#order-status-fallback');
        this.orderStatus = this.interestSubmitted;

        this.summaryDetails = this.parent.el.querySelector('#summary-details');
        this.orderBrief = this.summaryDetails.querySelector('#order-brief');
        this.orderSelectionDetails = this.summaryDetails.querySelector('#order-selection-details');
        this.orderPickupDetails = this.summaryDetails.querySelector('#order-pickup-details');
        this.orderPartexDetails = this.summaryDetails.querySelector('#order-partex-details');
        this.orderCostBreakdown = this.summaryDetails.querySelector('#order-cost-breakdown');
        this.orderDeposits = this.summaryDetails.querySelector('#order-deposits');
        this.totalPayable = this.summaryDetails.querySelector('#total-payable');
        this.ctaPayHoldingDeposit = this.parent.el.querySelector('.cta-pay-holding-deposit');
        this.statusesForExpectedHandoverDate = [orderStatus.interestSubmitted, orderStatus.awaitingDepositPayment, orderStatus.depositPlaced, orderStatus.orderConfirmed, orderStatus.orderCancelled, orderStatus.awaitingConfigurationConfirmation, orderStatus.configurationConfirmed, orderStatus.awaitingSalesContractSignature, orderStatus.salesContractSigned];
        this.statusesForHandoverDateTime = [orderStatus.handoverBooked, orderStatus.finalBalanceDue, orderStatus.readyForHandover, orderStatus.handoverComplete];
        this.cancelEditSection = this.el.querySelector('.cancel-edit-section');
        this.cancelRequestCtaElement = this.cancelEditSection.querySelector('.cancel-request-cta');
        if (this.cancelRequestCtaElement) {
            this.anchorElement = this.cancelRequestCtaElement.querySelector('a');
            this.requestCancellationLink = this.anchorElement?.href;
        }

        this.templates = {
            orderBrief: _.template(this.summaryDetails.querySelector('#order-brief-template').innerHTML.replaceAll('\\', '')),
            orderSelectionDetails: _.template(this.summaryDetails.querySelector('#order-selection-details-template').innerHTML.replaceAll('\\', '')),
            orderPickupDetails: _.template(this.summaryDetails.querySelector('#order-pickup-details-template').innerHTML.replaceAll('\\', '')),
            orderPartexDetails: _.template(this.summaryDetails.querySelector('#order-partex-details-template').innerHTML.replaceAll('\\', '')),
            orderCostBreakdown: _.template(this.summaryDetails.querySelector('#order-cost-breakdown-template').innerHTML.replaceAll('\\', '')),
            orderDeposits: _.template(this.summaryDetails.querySelector('#order-deposits-template').innerHTML.replaceAll('\\', '')),
            totalPayable: _.template(this.summaryDetails.querySelector('#total-payable-template').innerHTML.replaceAll('\\', '')),
        };

        // timeline
        this.timelineMainWrapper = parent.el.querySelector('#order-timeline');
        this.timelineWrapper = parent.el.querySelector('#order-timeline-items');
        this.timelineItemHeaders = this.timelineWrapper.querySelectorAll('.timeline-item--header');

        this.timelineItems = {
            configuration: this.timelineWrapper.querySelector('#timeline-configuration'),
            valuation: this.timelineWrapper.querySelector('#timeline-valuation'),
            paymentOption: this.timelineWrapper.querySelector('#timeline-payment-option'),
            holdingDeposit: this.timelineWrapper.querySelector('#timeline-holding-deposit'),
            financeApplication: this.timelineWrapper.querySelector('#timeline-finance-application'),
            orderProcessing: this.timelineWrapper.querySelector('#timeline-order-processing'),
            vehicleInProduction: this.timelineWrapper.querySelector('#timeline-vehicle-in-production'),
            vehicleInTransit: this.timelineWrapper.querySelector('#timeline-vehicle-in-transit'),
            vehicleArrivedRetailer: this.timelineWrapper.querySelector('#timeline-vehicle-arrived-retailer'),
            orderComplete: this.timelineWrapper.querySelector('#timeline-order-complete'),
        };

        this.timelineTemplates = {
            configuration: this.getCompiledTemplate('#timeline-configuration-template'),
            valuation: this.getCompiledTemplate('#timeline-valuation-template'),
            paymentOption: this.getCompiledTemplate('#timeline-payment-option-template'),
            holdingDeposit: this.getCompiledTemplate('#timeline-holding-deposit-template'),
            financeApplication: this.getCompiledTemplate('#timeline-finance-application-template'),
            orderProcessing: this.getCompiledTemplate('#timeline-order-processing-template'),
            vehicleInProduction: this.getCompiledTemplate('#timeline-vehicle-in-production-template'),
            vehicleInTransit: this.getCompiledTemplate('#timeline-vehicle-in-transit-template'),
            vehicleArrivedRetailer: this.getCompiledTemplate('#timeline-vehicle-arrived-retailer-template'),
            orderComplete: this.getCompiledTemplate('#timeline-order-complete-template'),
        };

        this.selectedIndex = 0;

        // Order Document
        this.orderDocumentWrapper = parent.el.querySelector('#timelineOrderDocuments');

        this.bind();
    }

    getCompiledTemplate(selector) {
        var templateStr = this.parent.el.querySelector(selector)?.innerHTML.replace(/\\/g, '');
        return templateStr ? _.template(templateStr, this.templateSettings) : null;
    }

    show() {
        this.el.classList.remove('hide');
        this.scrollToId();
    }

    hide() {
        this.el.classList.add('hide');
    }

    showElements(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('hide');
        });
    }

    hideElements(elementList) {
        elementList.forEach((element) => {
            element.classList.add('hide');
        });
    }

    bind() {
        window.HONDA.MyAccount2.addEventListener('login', () => this.getOrdersData());

        this.timelineItems.holdingDeposit.addEventListener('click', (e) => {
            if (e.target.closest('#tncLink')) {
                e.preventDefault();
                this.el.querySelector('#order-tab-accept-terms').scrollIntoView();
            }
        });

        this.bindTimeline();
        this.bindOrderDocuments();
    }

    formatCurrency(val, allowZero) {
        const value = val !== null && !isNaN(val) ? +val : NaN;

        if (isNaN(value)) {
            return window?.HONDA?.MyAccount2Labels.missingPrice ?? '';
        }

        if (!allowZero && value === 0) {
            return window?.HONDA?.MyAccount2Labels?.asStandard ?? '';
        }

        return this.currencyFormatter.to(value);
    }

    async getOrdersData() {
        this.orders = await window.HONDA.MyAccount2.client.getOrders();
        this.IsforceHide = this.parent.nav.el.querySelectorAll('.my-account-nav--item[data-force-hide="true"]').length > 0;

        if (this.orders.length && !this.IsforceHide) {
            this.parent.nav.toggle('#orders', true);
            this.container.classList.remove('hide');
            this.populate();
            this.checkSameSaveConfig(this.orders);
        } else {
            this.parent.nav.toggle('#orders', false);
            this.container.classList.add('hide');
            if (this.router.path === '#orders') {
                this.router.update('dashboard');
            }
        }
    }

    async getDealerLink(order) {
        const url = this.dealerUrl;
        const dealer = order.dealer.dealerCode;
        const result = await window.HONDA.MyAccount2.client.getDealerDetails(url, dealer);
        return result?.dealer?.alias;
    }

    async getPaymentLink(order) {
        const result = await window.HONDA.MyAccount2.client.getPaymentLink(order);
        const currentPage = [location.protocol, '//', location.host, location.pathname].join('');

        if (result?.paymentLink) {
            return `${result?.paymentLink}&successURL=${currentPage}&cancelURL=${currentPage}&pendingURL=${currentPage}`;
        }

        const link = await this.getDealerLink(order);
        this.retailerLink.href = link;
        this.showElements([this.retailerLinkContainer]);
    }

    checkSameSaveConfig(orders) {
        const savedItems = HONDA?.SaveForLater?.saveForLater?.saved || [];
        orders.forEach((order) => {
            if (order?.orderStatus !== 'Handover Complete') {
                const productId = order?.productIdList.find((el) => el.c_isMtoce === 'true')?.productId;
                if (productId) {
                    savedItems?.forEach((el) => {
                        const orderCreationDate = new Date(order?.creationDate);
                        const savedItemsCreationDate = new Date(el.data?.dateCreated);
                        if (el.data?.mtoce === productId && savedItemsCreationDate.getTime() < orderCreationDate.getTime()) {
                            window.HONDA.SaveForLater?.saveForLater?.remove({ data: { id: el.data?.id } });
                        }
                    });
                }
            }
        });
    }

    populate() {
        this.populateOrdersDropdown();
        this.populateOrder();
    }

    populateOrdersDropdown() {
        if (this.orders?.length > 0) {
            this.orders.sort((a, b) => {
                if (a.orderStatus !== 'Order Cancelled' && b.orderStatus !== 'Order Cancelled') {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                }
                const x = a.orderStatus === 'Order Cancelled' ? 1 : 0;
                const y = b.orderStatus === 'Order Cancelled' ? 1 : 0;
                return x - y;
            });
            this.el.querySelector('.order-dropdown').innerHTML = this.orderIDTemplate({
                orders: this.orders,
                formatCurrency: this.formatCurrency.bind(this),
            });
            this.bindOrdersDropdown();
        }
    }

    bindOrdersDropdown() {
        this.el.querySelector('.card--order-no-options').addEventListener('change', (e) => {
            this.selectedIndex = e.currentTarget.selectedIndex || 0;
            this.populateOrder(this.selectedIndex);
        });
    }

    getDeliveryTime({ order, locale }) {
        const date = this.statusesForExpectedHandoverDate.includes(order.orderStatus) ? order.expectedHandoverDate : order.handoverDateTime;
        return DateHelper.getFormattedDate({ date, locale, dateTimeFormatOptions: { hour: '2-digit', minute: '2-digit', hour12: false } });
    }

    getDisplayDate({ order, locale }) {
        if (this.statusesForExpectedHandoverDate.includes(order.orderStatus) && order.expectedHandoverDate) {
            return DateHelper.getFormattedDate({
                date: order.expectedHandoverDate, locale, dateTimeFormatOptions: { month: 'long', year: 'numeric' },
            });
        }
        if (this.statusesForHandoverDateTime.includes(order.orderStatus) && order.handoverDateTime) {
            return DateHelper.getFormattedDate({
                date: order.handoverDateTime, locale: 'en-GB', dateTimeFormatOptions: {},
            });
        }
        return '';
    }

    async getAdditionalData(order) {
        const htmlElement = document.getElementsByTagName('html')[0];
        const locale = htmlElement.getAttribute('lang');
        const additionalData = {
            estimatedDeliveryTime: this.getDisplayDate({ order, locale }),
            isValidOrderStatus: Object.values(orderStatus).includes(order.orderStatus),
            deliveryTime: this.getDeliveryTime({ order, locale }),
        };

        if (order.status && order.status !== 'OK') {
            return additionalData;
        }

        switch (order.orderStatus) {
        case orderStatus.interestSubmitted:
            break;
        case orderStatus.awaitingConfigurationConfirmation:
            additionalData.link = order.links?.ssignDocs?.find((doc) => doc.type === 'Order Form')?.link;
            break;
        case orderStatus.awaitingSalesContractSignature:
            additionalData.link = order?.links?.ssignDocs?.find((doc) => doc.type === 'Customer Sales Contract')?.link;
            break;
        case orderStatus.handoverBooked:
            additionalData.link = await this.getDealerLink(order);
            break;
        case orderStatus.finalBalanceDue: {
            const finalBalanceDue = new FinalBalanceDue({ payments: order.payments });
            const {
                paymentDue, remainingBalance, ctaLink, isFinalInstalment, allPaymentsComplete, tabColours,
            } = finalBalanceDue.build();
            const documentFinalInvoice = order.documents.find((document) => document.documentType === 'Final Invoice');
            additionalData.document = documentFinalInvoice;
            additionalData.finalBalanceDue = {
                tabColours,
                paymentDue,
                remainingBalance,
                ctaLink,
                isFinalInstalment,
                nextPaymentNumber: finalBalanceDue.getIndexOfNextPayment() + 1,
                numberOfPayments: finalBalanceDue.payments.length,
                allPaymentsComplete,
            };
            break;
        }

        default:
            break;
        }

        return additionalData;
    }

    hasPaymentQueryParam() {
        const queryParams = new URLSearchParams(location.search);
        const paymentStatus = queryParams.get('paymentStatus');
        return paymentStatus === 'AUTHORISED';
    }

    hasNotAcceptedTerms(order) {
        return order.orderStatus === orderStatus.interestSubmitted && !localStorage.getItem('ma2-checkout-terms');
    }

    getOrderStatusTemplate(order) {
        if (order.status && order.status !== 'OK') {
            return this.invalidOrderTemplate;
        }

        if (order?.cancellationCase && order.orderStatus !== 'Order Cancelled') {
            return this.orderStatusCancellationPending;
        }

        const status = order.orderStatus;
        const template = {
            [orderStatus.interestSubmitted]: this.hasPaymentQueryParam(order) ? this.awaitingDepositPaymentTemplate : this.interestSubmitted,
            [orderStatus.awaitingDepositPayment]: this.awaitingDepositPaymentTemplate,
            [orderStatus.depositPlaced]: this.depositPlacedTemplate,
            [orderStatus.orderConfirmed]: this.orderConfirmedTemplate,
            [orderStatus.orderCancelled]: this.orderCancelledTemplate,
            [orderStatus.cancellationPending]: this.orderStatusCancellationPending,
            [orderStatus.awaitingConfigurationConfirmation]: this.awaitingConfigurationConfirmationTemplate,
            [orderStatus.configurationConfirmed]: this.configurationConfirmedTemplate,
            [orderStatus.awaitingSalesContractSignature]: this.awaitingB2CSalesContractSignatureTemplate,
            [orderStatus.salesContractSigned]: this.b2CSalesContractSignedTemplate,
            [orderStatus.handoverBooked]: this.handoverBookedTemplate,
            [orderStatus.finalBalanceDue]: this.finalBalanceDueTemplate,
            [orderStatus.readyForHandover]: this.readyForHandoverTemplate,
            [orderStatus.handoverPending]: this.handoverPendingTemplate,
            [orderStatus.handoverComplete]: this.handoverCompleteTemplate,
            fallback: this.orderStatusFallbackTemplate,
        };

        return template[status] || template.fallback;
    }

    async populateOrder(selectedIndex) {
        const orderIndex = selectedIndex || 0;
        const order = this.orders[orderIndex];
        if (!order) { return; }
        const excludedStatuses = ['Interest Submitted', 'Awaiting Deposit Payment', 'Cancellation Pending', 'Order Cancelled', 'Handover Complete'];
        if (this.cancelRequestCtaElement && this.anchorElement && order?.orderId && !order?.cancellationCase && !excludedStatuses.includes(order?.orderStatus)) {
            this.cancelRequestCtaElement.style.display = 'block';
            this.anchorElement.href = this.requestCancellationLink + order.orderId;
        } else {
            this.cancelRequestCtaElement.style.display = 'none';
        }

        const additionalData = await this.getAdditionalData(order);

        if (order.orderStatus === 'Order Cancelled') {
            this.container.classList.add('order-cancelled');
        }

        this.el.querySelector('.order-summary-tile').innerHTML = this.orderSummaryTileTemplate({
            order,
            additionalData,
            utils: this.utils,
        });

        if (additionalData.isValidOrderStatus) {
            this.el.querySelector('.order-summary-cta-wrapper').classList.remove('hide');
            this.el.querySelector('.order-dropdown').classList.remove('hide');
        } else {
            this.el.querySelector('.order-summary-cta-wrapper').classList.add('hide');
            this.el.querySelector('.order-dropdown').classList.add('hide');
        }

        this.el.querySelector('.cancel-edit-link').addEventListener('click', (e) => {
            e.preventDefault();
            this.cancelEditSection.scrollIntoView(true);
            AnalyticsHelper.push({
                event: 'order_cancel_edit',
                eventCategory: 'my order',
                eventAction: 'cancel or edit order',
                eventLabel: `cars|${order?.summary?.ids?.modelCode}|My Account|cancel or edit order|internal|top|#|${order?.orderStatus}|${(order?.financeStatus ? order?.financeStatus : '')}`,
                businessUnit: 'cars',
                actionType: 'cancel or edit order',
                moduleName: 'My Account',
                clickText: 'cancel or edit order',
                clickType: 'internal',
                destinationURL: '#',
                modelSelected: order?.summary?.ids?.modelCode,
                inPageLocation: 'top',
                orderStatus: order?.orderStatus,
                financeStatus: (order?.financeStatus ? order?.financeStatus : '')
            });
        });

        this.el.querySelector('.cta-view-order').addEventListener('click', (e) => {
            e.preventDefault();
            this.el.classList.add('view-order-summary');
            AnalyticsHelper.push({
                event: 'order_view_order',
                eventCategory: 'my order',
                eventAction: 'view your order',
                eventLabel: `cars|${order?.summary?.ids?.modelCode}|My Account|view your order|internal|top|#|${order?.orderStatus}|${(order?.financeStatus ? order?.financeStatus : '')}`,
                businessUnit: 'cars',
                actionType: 'view your order',
                moduleName: 'My Account',
                clickText: 'view your order',
                clickType: 'internal',
                destinationURL: '#',
                modelSelected: order?.summary?.ids?.modelCode,
                inPageLocation: 'top',
                orderStatus: order?.orderStatus,
                financeStatus: (order?.financeStatus ? order?.financeStatus : '')
            });
        });

        this.summaryDetails.addEventListener('click', (e) => {
            if (e.target.matches('#back-to-order')) {
                e.preventDefault();
                this.el.classList.remove('view-order-summary');
            }
        });

        this.orderStatus = this.getOrderStatusTemplate(order);

        this.el.querySelector('.orders-tab-status').innerHTML = this.orderStatus({
            order,
            additionalData,
            utils: this.utils,
            formatCurrency: this.formatCurrency.bind(this),
        });

        await this.postOrderStatusRender(order);
        this.el.querySelector('.timelineOrderDocuments').innerHTML = this.timelineOrderDocumentsTemplate({
            order, additionalData, dateFormat, setFinanceCategory: this.setFinanceCategory
        });

        this.populateSummaryDetails(orderIndex);
        this.renderTimeline();
        if (this.router.path === '#orders') {
            AnalyticsHelper.push({
                event: 'order_select',
                eventCategory: 'my order',
                eventAction: 'select',
                eventLabel: `cars|${order?.summary?.ids?.modelCode}|My Account|${order?.summary?.ids?.modelCode}|dropdown|top||${order?.orderStatus}|${(order?.financeStatus ? order?.financeStatus : '')}`,
                actionType: 'select',
                businessUnit: 'cars',
                moduleName: 'My Account',
                destinationURL: '',
                clickText: order?.orderId,
                clickType: 'internal',
                modelSelected: order?.summary?.ids?.modelCode,
                inPageLocation: 'top',
                orderStatus: order?.orderStatus,
                financeStatus: (order?.financeStatus ? order?.financeStatus : ''),
                depositAmount: order?.dealStack?.holdingDeposit,
            });
        }
    }

    async postOrderStatusRender(order) {
        switch (order.orderStatus) {
        case orderStatus.interestSubmitted:
            this.bindFinanceQuoteLink(order);
            this.bindTermsAndCondition(order);
            this.bindPaymentCTA({
                root: this.el,
                btn: '.pay-deposit-button',
                loader: '.order-status-wrapper .form_builder_loader',
                order,
                setTerms: true
            });
            break;
        default:
            break;
        }
    }

    bindFinanceQuoteLink(order) {
        const downloadQuoteLink = this.el.querySelector('.download-finance-quote');
        if (downloadQuoteLink && order.financeQuotePDFBase64) {
            downloadQuoteLink.addEventListener('click', (event) => {
                event.preventDefault();
                DownloadBase64.downloadPDF(order.financeQuotePDFBase64, `honda-finance-quote-${order.orderId}`);
            });
        }
    }

    bindTermsAndCondition(order) {
        const payDepositBtn = this.el.querySelector('.pay-deposit-button');
        const checkboxContainer = this.el.querySelector('.checkbox_container');
        if (this.hasNotAcceptedTerms(order) && payDepositBtn) {
            payDepositBtn.classList.add('disabled');
            checkboxContainer.classList.remove('hide');
            const checkboxes = [...this.el.querySelectorAll('.order-checkbox')];
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    const allChecked = checkboxes.every((c) => c.checked);
                    if (allChecked) {
                        payDepositBtn.classList.remove('disabled');
                    } else {
                        payDepositBtn.classList.add('disabled');
                    }
                });
            });
        }
    }

    bindPaymentCTA({ root = document, btn, loader, order, setTerms = false }) {
        const buttons = Array.from(root.querySelectorAll(btn));
        if (!buttons.length) return;
        const loaderEl = root.querySelector(loader);
        buttons.forEach(b => {
            if (b.dataset.paymentBound) return;
            b.dataset.paymentBound = '1';

            b.addEventListener('click', async (e) => {
                e.preventDefault();
                if (b.classList.contains('disabled')) return;

                loaderEl?.classList.remove('hide');
                if (setTerms) localStorage.setItem('ma2-checkout-terms', true);

                try {
                    const link = await this.getPaymentLink(order);
                    loaderEl?.classList.add('hide');
                    window.location = link;
                } catch (err) {
                    loaderEl?.classList.add('hide');
                    console.error('Payment link failed', err);
                }
            });
        });
    }

    async renderTimeline() {
        const order = this.orders[this.selectedIndex];
        const additionalData = {};
        const partExArray = this.normalisePartEx(order);

        if (order.orderStatus === 'Interest Submitted') {
            additionalData.hasPaymentQueryParam = this.hasPaymentQueryParam(order);
        }

        const data = {
            order,
            additionalData,
            dateFormat,
            stringReplace: StringUtils.replace,
            formatCurrency: this.formatCurrency.bind(this),
            getPercentage: ({ number, numberOfDecimals }) => `${getNumberWithDecimals({ number, numberOfDecimals })}%`,
            tncStatus: Boolean(localStorage.getItem('ma2-checkout-terms')),
            partEx: partExArray,
        };

        if ((order.status && order.status !== 'OK') || order.orderStatus === 'Order Cancelled' || this.hasNotAcceptedTerms(order)) {
            this.timelineMainWrapper.classList.add('hide');
        } else {
            this.timelineMainWrapper.classList.remove('hide');
            for (const [key, value] of Object.entries(this.timelineItems)) {
                this.timelineItems[key].innerHTML = this.timelineTemplates[key](data);
            }
        }

        if (order.orderStatus === 'Interest Submitted') {
            this.bindPaymentCTA({
                root: this.timelineWrapper,
                btn: '.cta-pay-holding-deposit',
                loader: '#timeline-holding-deposit .form_builder_loader',
                order
            });
        }
        Tooltip.init();
        Tooltip.init('.discount-tooltip');
    }

    populateSummaryDetails(index) {
        const order = this.orders[index];
        const partExArray = this.normalisePartEx(order);

        const data = {
            order,
            dateFormat,
            stringReplace: StringUtils.replace,
            escapeHTML,
            formatCurrency: this.formatCurrency.bind(this),
            getPercentage: ({ number, numberOfDecimals }) => `${getNumberWithDecimals({ number, numberOfDecimals })}%`,
            partEx: partExArray,
            promotions: addTooltips(order?.summary?.promotions),
            promotionsBannerContent: getBanner(order.summary?.promotions),
        };

        this.orderBrief.innerHTML = this.templates.orderBrief(data);
        this.orderSelectionDetails.innerHTML = this.templates.orderSelectionDetails(data);
        this.orderPickupDetails.innerHTML = this.templates.orderPickupDetails(data);
        this.orderPartexDetails.innerHTML = this.templates.orderPartexDetails(data);
        this.orderCostBreakdown.innerHTML = this.templates.orderCostBreakdown(data);
        this.orderDeposits.innerHTML = this.templates.orderDeposits(data);
        this.totalPayable.innerHTML = this.templates.totalPayable(data);

        Tooltip.init();
        Tooltip.init('.discount-tooltip');
    }

    bindTimeline() {
        this.timelineWrapper.addEventListener('click', (e) => {
            if (e.target.closest('.timeline-item--header')) {
                e.preventDefault();

                const parent = e.target.closest('.timeline-item');

                if (parent.classList.contains('open')) {
                    parent.classList.remove('open');
                } else {
                    parent.classList.add('open');
                }
            }

            if (e.target.closest('.order-document--header')) {
                e.preventDefault();
                const parent = e.target.closest('.order-document');

                if (parent.classList.contains('active')) {
                    parent.classList.remove('active');
                } else {
                    parent.classList.add('active');
                }
            }
        });
    }

    bindOrderDocuments() {
        this.orderDocumentWrapper.addEventListener('click', (e) => {
            if (e.target.closest('.order-document--header')) {
                e.preventDefault();
                const orderDocumentCard = e.target.closest('.order-documents-card');
                const orderDocument = e.target.closest('.order-document');

                const isActive = orderDocument.classList.contains('active');
                orderDocumentCard.querySelectorAll('.order-document').forEach((e) => e.classList.remove('active'));
                if (!isActive) {
                    orderDocument.classList.add('active');
                }
            }
        });
    }

    scrollToId() {
        const id = this.router.params.get('id');
        if (id) {
            const el = this.el.querySelector(`#${id}`);
            el?.scrollIntoView({ behavior: 'smooth' });
        }
    }

    normalisePartEx(order) {
        if (Array.isArray(order.partEx) && order.partEx.length > 0 && Object.keys(order.partEx[0]).length > 0) {
            return order.partEx;
        } if (order.partEx != null && Object.keys(order.partEx).length > 0) {
            return [{ ...order.partEx }];
        }
        return [];
    }

    setFinanceCategory(financeDocumentList) {
        const todaysDate = new Date();

        financeDocumentList.forEach((document, index) => {
            if (index === 0) {
                document.category = 'final';
            } else if (new Date(document?.createdDate).setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
                document.category = 'new';
            } else {
                document.category = 'expired';
            }
        });

        return financeDocumentList;
    }
}
